import axios from 'axios';

export class AforoService {
    getDataAforo(idAforo, instrumentLoan, instrumentGuarantee, first, rows) {
        let paramsTemp = {
            start: first,
            limit: rows,
            sort: "tipoAforo",
            dir: "ASC",
            emisoraPrestamo: instrumentLoan ? instrumentLoan : "",
            emisoraGarantia: instrumentGuarantee ? instrumentGuarantee : "",
        };
        if (idAforo) {
            paramsTemp['idAforo'] = idAforo
        }
        return axios.get('/appapv/getCapacityKey.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: paramsTemp
        }).then(res => res.data);
    }

    updateAforo(dataAforo) {
        return axios.post('/appapv/updateCapacityKey.action', {}, {
            params: {
                idAforo: dataAforo.idTipoAforo,
                emisoraPrestamo: dataAforo.emisoraPrestamo,
                emisoraGarantia: dataAforo.emisoraGarantia,
                aforoporc: dataAforo.porcAforo,
            }
        }).then(res => res.data);
    }

}